module.exports = __webpack_public_path__ + "img/刷卡读卡器 (1).d98ac50e.jpg";